import { MapsAPILoader } from '@ng-maps/core';
import { Injectable } from '@angular/core';
import Coordinates from '../model/coordinates';

@Injectable({
  providedIn: 'root',
})
export class GeocoderService {
  private geocoder: google.maps.Geocoder;
  private geocodeInitPromise: Promise<void>;

  constructor(private mapsAPILoader: MapsAPILoader) {
    this.geocodeInitPromise = this.getGeocodeInitPromise();
  }

  private async getGeocodeInitPromise(): Promise<void> {
    await this.mapsAPILoader.load();
    this.geocoder = new google.maps.Geocoder();
  }

  geocodeAddress(addressString: string): Promise<Coordinates> {
    return this.geocodeInitPromise.then(
      () =>
        new Promise((resolve, reject) => {
          this.geocoder.geocode(
            { address: addressString },
            (results, status) => {
              if (status === google.maps.GeocoderStatus.OK) {
                const toReturn = new Coordinates();
                toReturn.lat = results[0].geometry.location.lat();
                toReturn.lng = results[0].geometry.location.lng();
                return resolve(toReturn);
              } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                return resolve(null);
              } else {
                return reject(
                  new Error(`geocode call failed with status: ${status}`)
                );
              }
            }
          );
        })
    );
  }
}
